import type { IUserProfileRepository } from "@/application/ports/repositories";
import {
  DEFAULT_USER_PREFERENCES,
  type ChangePasswordRequest,
  type EmailChangeRequest,
  type UpdateUserPreferencesRequest,
  type UpdateUserProfileRequest,
  type UserPreferences,
  type UserProfileResponse,
} from "@/domain/user";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class UserProfileRepository implements IUserProfileRepository {
  async getProfile(signal?: AbortSignal): Promise<UserProfileResponse> {
    return unwrap(sdk.getMe({ signal }));
  }
  async updateProfile(data: UpdateUserProfileRequest): Promise<UserProfileResponse> {
    return unwrap(sdk.updateMe({ body: data }));
  }
  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await unwrap(sdk.changePassword({ body: data }));
  }
  async updatePreferences(data: UpdateUserPreferencesRequest): Promise<UserPreferences> {
    const profile = await unwrap(sdk.updateMe({ body: { preferences: data } }));
    return profile.preferences ?? DEFAULT_USER_PREFERENCES;
  }
  async requestEmailChange(data: EmailChangeRequest): Promise<void> {
    await unwrap(sdk.requestEmailChange({ body: data }));
  }
  async cancelEmailChange(): Promise<void> {
    await unwrap(sdk.cancelEmailChange());
  }
  async setDefaultOrganization(organizationUuid: string): Promise<void> {
    await unwrap(sdk.setDefaultMembership({ body: { organization_uuid: organizationUuid } }));
  }
}
